import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  Grid2,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { IoMdCloseCircleOutline } from "react-icons/io";
import {
  getServiceVisits,
  visitActions,
  permitRemainingDays,
} from "../../../../Service/serviceVisits";
import Callmodal from "../visitModels/call";
import CloseDuty from "../visitModels/closeDuty";
import PaymentIssue from "../visitModels/paymentIssue";
import Oncall from "../visitModels/oncall";
import moment from "moment";

const CustomSelect = styled(Select)({
  "& .MuiSelect-select": {
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  borderRadius: 5,
});
const buttonStyle = {
  backgroundColor: "white",
  color: "#504EFF",
  fontSize: "12px",
  textTransform: "none",
  width: "20vh",
};

const VisitTabs = ({ selectedTab, handleTabChange }) => {
  return (
    <div className="mb-4">
      <div
        className="gap-5 "
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Button
          // variant={selectedTab === 0 ? "outlined" : "contained"}
          onClick={() => handleTabChange(null, 0)}
          style={{
            borderRadius: "8px",
            width: "50%",
            backgroundColor: "#fff",
            color: selectedTab === 0 ? "#504EFF" : "gray",
            textTransform: "none",
          }}
          className="shadow-md"
        >
          Regular
        </Button>
        <Button
          // variant={selectedTab === 1 ? "outlined" : "contained"}
          onClick={() => handleTabChange(null, 1)}
          style={{
            borderRadius: "8px",
            width: "50%",
            backgroundColor: "#fff",
            color: selectedTab === 1 ? "#504EFF" : "gray",
            textTransform: "none",
          }}
          className="shadow-md"
        >
          24/7
        </Button>
      </div>
    </div>
  );
};

const VisitsTable = ({ commonTableCellStyle, selectedTab, timeOfDay }) => {
  const [visits, setVisits] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState();
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [btnShow, setBtnShow] = useState(false);

  const handleButtonClick = (item, visit) => {
    setSelectedVisit(visit);
    setModalContent(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent("");
  };

  useEffect(() => {
    getLiveVisits();
  }, [timeOfDay]);

  const getLiveVisits = async () => {
    try {
      const res = await getServiceVisits();

      if (!res.error && Array.isArray(res.data) && res.data.length > 0) {
        const filteredData = res.data.filter((visit) => {
          const dutyType = visit?.visitInfo?.shiftType;

          if (!dutyType) return false;

          if (dutyType === "24/7,24H" || dutyType === "1 Day") {
            return true;
          }

          const [dutyPrefix] = dutyType.split(",");
          return dutyPrefix === timeOfDay;
        });

        setVisits(filteredData);
      } else {
        setVisits([]);
      }
    } catch (e) {
      console.error("Error fetching visits:", e);
      setVisits([]);
    }
  };

  const handleServiceStatusChange = async (event, visit) => {
    let value = event.target.value;
    console.log(value);

    if (value === "cancelled") {
      setShowModal(true);
      setBtnShow(false);
    }

    let data = {
      visitID: visit._id,
      dutyID: visit.dutyInfo[0]._id,
      status: value,
    };

    let updateStatus = await visitActions(data);
    if (updateStatus.error === false) {
      console.log(updateStatus.data);
      getLiveVisits();
    }
  };

  console.log(showModal);

  // Filter visits based on dutyType.
  const filteredVisits = visits.filter((visit) => {
    const dutyType = visit?.visitInfo?.shiftType;
    if (selectedTab === 1) {
      // Show only 24/7 visits.
      return dutyType === "24/7,24H";
    } else {
      // Regular visits: exclude 24/7 types.
      return !(dutyType === "24/7,24H");
    }
  });

  // Compute status for a given visit.
  const status = (visit) => {
    let currentStatus;
    const dutyStatus = visit.dutyInfo[0].liveStatus;
    const startTime = visit.dutyInfo[0].startTime;
    const endTime = visit.dutyInfo[0].endTime;
    const currentTime = new Date().getTime();

    if (dutyStatus === "pending") {
      currentStatus = "Not Responded";
    } else if (dutyStatus === "cancelled") {
      currentStatus = "Not Attending";
    } else if (dutyStatus === "confirmed") {
      currentStatus =
        currentTime > new Date(startTime).getTime()
          ? "Duty Not Started"
          : "Responded";
    } else if (dutyStatus === "started") {
      currentStatus =
        currentTime > new Date(endTime).getTime()
          ? "Duty Not Ended"
          : "Duty Started";
    } else if (dutyStatus === "closed") {
      currentStatus = "Duty Ended";
    }

    return currentStatus;
  };
  let todayDate = moment().format("YYYY-MM-DD");

  const OnConfirm = async (visit) => {
    if (!visit) {
      console.error("No visit data provided");
      return;
    }

    const userConfirmed = window.confirm(
      "Once you proceed, this action cannot be undone, and you will not be able to do any changes for this visit for today."
    );

    if (!userConfirmed) {
      return;
    }
    console.log(visit);

    const data = {
      visitID: visit?._id,
      specialistID: visit?.specialistInfo?.userID,
      formattedDate: moment().format("YYYY-MM-DD"),
    };

    console.log("Request payload:", data);

    try {
      const response = await permitRemainingDays(data);

      if (response?.error === false) {
        // console.log("Success:", response.data);
        if (response.data.status === "endDuty") {
          let data = {
            visitID: visit._id,
            dutyID: visit.dutyInfo[0]._id,
            status: "closed",
          };

          let updateStatus = await visitActions(data);
          if (updateStatus.error === false) {
            getLiveVisits();
          }
        }
      } else {
        console.error("Request failed:", response?.error || "Unknown error");
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const OnClose = () => {
    setShowModal(false);
    setBtnShow(true);
  };
  console.log(selectedVisit);
  return (
    <div>
      <Card
        style={{
          boxShadow: "none",
          border: "none",
          borderRadius: "12px",
        }}
      >
        <CardContent style={{ paddingLeft: 0, paddingRight: 0 }}>
          <TableContainer>
            <Table size="small">
              <TableHead style={{ backgroundColor: "#F7F8FA" }}>
                <TableRow style={{}}>
                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Role
                  </TableCell>
                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Patient
                  </TableCell>
                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Service Status
                  </TableCell>
                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Time
                  </TableCell>

                  <TableCell
                    style={{
                      commonTableCellStyle,
                      color: "#8177A8",
                      fontWeight: 500,
                      fontSize: 13,
                    }}
                  >
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredVisits.map((visit) => (
                  <TableRow key={visit._id}>
                    <TableCell
                      style={{
                        color: "#4951EC",
                        commonTableCellStyle,
                        fontSize: "12px",
                      }}
                    >
                      {visit?.specialistInfo?.name}
                    </TableCell>
                    <TableCell
                      style={{ commonTableCellStyle, fontSize: "13px" }}
                    >
                      {visit?.specialistInfo?.role
                        ?.split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        )
                        .join(" ")}
                    </TableCell>
                    <TableCell
                      style={{
                        color: "#4951EC",
                        commonTableCellStyle,
                        fontSize: "12px",
                        width: "20vh",
                      }}
                    >
                      {visit?.patient?.name}
                    </TableCell>

                    <TableCell
                      style={{
                        ...commonTableCellStyle,
                        backgroundColor: "#F7F8FA",
                        height: "2vh",
                        borderRadius: 10,
                        fontSize: "12px",
                      }}
                    >
                      <Grid2 container spacing={1} alignItems="center">
                        <div className="flex flex-row items-center">
                          <div className="flex flex-col gap-2">
                            <Grid2>
                              {visit?.dutyInfo.map((item, idx) => {
                                if (
                                  item.date === todayDate &&
                                  item?.attendedBy?.role
                                ) {
                                  return (
                                    <span
                                      key={idx}
                                      style={{ fontSize: "13px" }}
                                    >
                                      {item.attendedBy.role === "oncall-nurse"
                                        ? "oncall"
                                        : "Regular duty"}
                                    </span>
                                  );
                                }
                                return null;
                              })}
                            </Grid2>
                            <Grid2
                              item
                              xs={6}
                              style={{
                                textAlign: "start",
                                width: "20vh",
                                fontSize: "10px",
                                color:
                                  status(visit) === "Not Attending"
                                    ? "#D549EC"
                                    : status(visit) === "Not Responded"
                                    ? "#8E8E8E"
                                    : status(visit) === "Responded"
                                    ? "#63A990"
                                    : status(visit) === "Accepted"
                                    ? "#63A990"
                                    : status(visit) === "Duty Not Started"
                                    ? "#D79445"
                                    : status(visit) === "Duty Not Ended"
                                    ? "#D79445"
                                    : "black",
                              }}
                            >
                              {status(visit)}
                            </Grid2>
                          </div>
                          <Grid2 item xs={6}>
                            <CustomSelect
                              value={visit?.dutyInfo[0]?.liveStatus}
                              onChange={(e) =>
                                handleServiceStatusChange(e, visit)
                              }
                              size="small"
                              fullWidth
                              disabled={
                                visit?.dutyInfo[0]?.liveStatus?.toLowerCase() ===
                                "closed"
                              }
                              style={{
                                backgroundColor: "fff",
                                width: "25vh",
                                border: "none",
                                fontSize: "12px",
                                color: "#7BA7D2",
                              }}
                            >
                              <MenuItem value="cancelled">
                                Not Attending
                              </MenuItem>
                              <MenuItem value="confirmed">Attending</MenuItem>
                              <MenuItem value="pending">Not Responded</MenuItem>
                              <MenuItem value="closed">Close Duty</MenuItem>
                            </CustomSelect>
                          </Grid2>
                        </div>
                      </Grid2>
                    </TableCell>

                    <TableCell
                      style={{
                        commonTableCellStyle,
                        fontSize: "12px",
                      }}
                    >
                      {visit?.visitInfo?.slot} (
                      {visit?.visitInfo?.shiftType.split(",")[1]})
                    </TableCell>

                    <TableCell
                      style={{
                        ...commonTableCellStyle,
                        backgroundColor: "#F7F8FA",
                      }}
                    >
                      {(() => {
                        const currentStatus = status(visit);
                        if (
                          currentStatus === "Responded" ||
                          currentStatus === "Duty Started" ||
                          currentStatus === "Duty Ended"
                        ) {
                          return null;
                        } else if (currentStatus === "Not Responded") {
                          return (
                            <Button
                              size="small"
                              style={buttonStyle}
                              onClick={() =>
                                handleButtonClick("Call Nurse", visit)
                              }
                            >
                              Call Nurse
                            </Button>
                          );
                        } else if (currentStatus === "Not Attending") {
                          return (
                            <>
                              {showModal && (
                                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                  <div className="bg-white p-10 rounded-md shadow-xl w-[380px] text-center relative">
                                    <button
                                      onClick={() => setShowModal(false)}
                                      className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl font-bold"
                                    >
                                      <IoMdCloseCircleOutline color="blue" />
                                    </button>

                                    <h2 className="text-[14px] font-medium mb-10">
                                      Permit the HCP to continue completing the
                                      remaining days of the visit.
                                    </h2>
                                    <div className="flex justify-center gap-4">
                                      <button
                                        onClick={OnClose}
                                        className="border border-blue-600 text-blue-600 px-8 py-1 rounded-lg"
                                      >
                                        No
                                      </button>
                                      <button
                                        onClick={() => OnConfirm(visit)}
                                        className="bg-custom-gradient text-white px-8 py-1 rounded-lg hover:bg-blue-700"
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {btnShow && (
                                <div className="flex flex-row items-center">
                                  <Button
                                    size="small"
                                    style={{
                                      ...buttonStyle,
                                      marginRight: "8px",
                                      // color:
                                      //   visit?.onCallRequests?.length > 0
                                      //     ? "gray"
                                      //     : "inherit",
                                    }}
                                    // disabled={visit?.onCallRequests?.length > 0}
                                    onClick={() =>
                                      handleButtonClick("Trigger Oncall", visit)
                                    }
                                  >
                                    Trigger Oncall
                                  </Button>
                                  <Button
                                    size="small"
                                    style={{ ...buttonStyle, color: "black" }}
                                    onClick={() =>
                                      handleButtonClick("Issue Payment", visit)
                                    }
                                  >
                                    Payment/Refund
                                  </Button>
                                </div>
                              )}
                            </>
                          );
                        } else if (currentStatus === "Duty Not Started") {
                          return (
                            <div className="flex flex-row items-center">
                              <Button
                                size="small"
                                style={{ ...buttonStyle, marginRight: "8px" }}
                                onClick={() =>
                                  handleButtonClick("Call Nurse", visit)
                                }
                              >
                                Call Nurse
                              </Button>
                              <Button
                                size="small"
                                style={buttonStyle}
                                onClick={() =>
                                  handleButtonClick("Call Patient", visit)
                                }
                              >
                                Call Patient
                              </Button>
                            </div>
                          );
                        } else if (currentStatus === "Duty Not Ended") {
                          return (
                            <Button
                              size="small"
                              style={buttonStyle}
                              onClick={() => handleButtonClick("Close Duty")}
                            >
                              Close Duty
                            </Button>
                          );
                        } else {
                          return null;
                        }
                      })()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
      {modalContent && (
        <>
          {modalContent === "Call Nurse" && (
            <Callmodal
              id={selectedVisit?.specialistInfo?.userID}
              name={selectedVisit?.specialistInfo?.name}
              role={selectedVisit?.specialistInfo?.role}
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            />
          )}
          {modalContent === "Call Patient" && (
            <Callmodal
              id={selectedVisit?.patient?.patientID}
              name={selectedVisit?.patient?.name}
              role={"patient"}
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            />
          )}
          {modalContent === "Close Duty" && (
            <CloseDuty isOpen={isModalOpen} onClose={handleCloseModal} />
          )}
          {modalContent === "Issue Payment" && (
            <PaymentIssue
              isOpen={isModalOpen}
              visit={selectedVisit}
              onClose={handleCloseModal}
            />
          )}
          {modalContent === "Trigger Oncall" && (
            <Oncall
              isOpen={isModalOpen}
              visit={selectedVisit}
              onClose={handleCloseModal}
            />
          )}
          {modalContent === "Not Attending" && (
            <Oncall
              isOpen={isModalOpen}
              visit={selectedVisit}
              onClose={handleCloseModal}
            />
          )}
        </>
      )}
    </div>
  );
};

const CheckVisitsContent = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [timeOfDay, setTimeOfDay] = useState("morning");

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleTimeOfDayChange = (event) => {
    setTimeOfDay(event.target.value);
  };

  const commonTableCellStyle = { padding: "8px" };

  return (
    <div style={{ gap: "24px", marginTop: 10, marginLeft: 12 }}>
      <VisitTabs selectedTab={selectedTab} handleTabChange={handleTabChange} />

      {selectedTab === 0 && (
        <Card
          style={{
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "12px",
            height: "80vh",
          }}
        >
          <CardContent>
            <Grid2 container spacing={2} justifyContent="space-between">
              <Grid2 item xs={6}>
                <Typography variant="h6" style={{ fontSize: "16px" }}>
                  Visit List
                </Typography>
              </Grid2>
              <Grid2 item xs={6} style={{ textAlign: "right" }}>
                <RadioGroup
                  row
                  aria-label="time-of-day"
                  name="timeOfDay"
                  value={timeOfDay}
                  onChange={handleTimeOfDayChange}
                >
                  <FormControlLabel
                    value="morning"
                    control={
                      <Radio
                        style={{
                          transform: "scale(0.8)",
                          color:
                            timeOfDay === "morning" ? "#504EFF" : "#9e9e9e",
                        }}
                      />
                    }
                    label="Morning"
                    style={{
                      fontSize: "12px",
                      marginLeft: "0px",
                      marginRight: "0px",
                      color: timeOfDay === "morning" ? "#504EFF" : "#000",
                    }}
                  />

                  <FormControlLabel
                    value="night"
                    control={
                      <Radio
                        style={{
                          transform: "scale(0.8)",
                          color: timeOfDay === "night" ? "#504EFF" : "#9e9e9e",
                          fontSize: "12px",
                        }}
                      />
                    }
                    label="Night"
                    style={{
                      fontSize: "12px",
                      marginLeft: "0px",
                      marginRight: "0px",
                      color: timeOfDay === "night" ? "#504EFF" : "#000",
                    }}
                  />
                </RadioGroup>
              </Grid2>
            </Grid2>
            <VisitsTable
              timeOfDay={timeOfDay}
              commonTableCellStyle={commonTableCellStyle}
              selectedTab={selectedTab}
            />
          </CardContent>
        </Card>
      )}

      {selectedTab === 1 && (
        <Card
          style={{
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "8px 8px 8px 8px",
          }}
        >
          <CardContent>
            <Typography variant="h6" style={{ fontSize: "16px" }}>
              24/7 Visit List
            </Typography>
            <VisitsTable
              timeOfDay={timeOfDay}
              commonTableCellStyle={commonTableCellStyle}
              selectedTab={selectedTab}
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default CheckVisitsContent;
